import { Check } from 'lucide-react';
import pluralize from 'pluralize';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type SuccessStepProps = {
  payrollName: string;
  employeeCount: number;
  amount: string;
  onMakeNewPayroll: () => void;
  onClose: () => void;
};

export const SuccessStep = ({ payrollName, employeeCount, amount, onMakeNewPayroll, onClose }: SuccessStepProps) => {
  return (
    <Stack align="stretch" space={16} className="w-full rounded-lg bg-white p-8">
      <Stack space={3} align="center">
        <Inline justify="center" className="h-20 w-20 rounded-full border border-primary bg-white p-4">
          <Check size={30} />
        </Inline>

        <Stack space={2} align="center">
          <p className="text-xl font-medium text-black">The payment has been made!</p>

          <p className="text-center text-base text-muted-foreground">Your payroll was processed</p>
        </Stack>
      </Stack>

      <Stack space={6} align="stretch">
        <Stack space={3} align="stretch">
          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Payroll Name</p>

            <p className="text-base font-medium text-black">{payrollName}</p>
          </Inline>

          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Employees</p>

            <p className="text-base font-medium text-black">
              {employeeCount} {pluralize('Employee', employeeCount)}
            </p>
          </Inline>

          <Inline justify="between">
            <p className="text-base font-medium text-muted-foreground">Total net pay</p>

            <p className="text-base font-medium text-black">{amount}</p>
          </Inline>
        </Stack>

        <Stack space={3} align="stretch">
          <Button variant="default" onClick={onMakeNewPayroll}>
            Make a new payroll
          </Button>

          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
